// extracted by mini-css-extract-plugin
export var content = "_d6-3";
export var list = "_d6-4";
export var settingsContent = "_d6-7";
export var settingsPanel = "_d6-8";
export var state = "_d6-6";
export var triggerBadge = "_d6-2";
export var triggerButton = "_d6-1";
export var triggerShell = "_d6-0";
export var unreadDot = "_d6-5";